import React, { ReactNode, useMemo } from 'react';
import { RowIdType } from '../../../../../../types';
import { useMappings } from '../../../../../../stores/mappingStore';
import { useHighlightsStoreActions } from '../../../../../../stores/highlightStore';
type AnnotationsTableRowPropsType = {
    children: ReactNode;
    rowId: RowIdType;
};

function AnnotationsTableRow({ children, rowId }: AnnotationsTableRowPropsType) {
    const mappings = useMappings();
    const highlightActions = useHighlightsStoreActions();

    const masterDescriptorId = useMemo(() => {
        return mappings.find((m) => m.rowId === rowId)?.descriptorId ?? null;
    }, [mappings]);

    return (
        <tr
            onPointerEnter={() => highlightActions.setDescriptorId(masterDescriptorId)}
            onPointerLeave={() => highlightActions.setDescriptorId(null)}
        >
            {children}
        </tr>
    );
}

export default AnnotationsTableRow;
